
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider } from './contexts/AuthContext';
import EventPopup from './components/EventPopup';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <AppRoutes />
        <EventPopup />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
